import fetchCategoryPosts from "common/fetch/fetchCategoryPosts";
import fetchSeo from "common/fetch/fetchSeo";

import Layout from "components/common/Layout";
import HongKongEcommerceGuideTemplate from "components/templates/hk/guide-and-tool/hong-kong-ecommerce-guide";

import dataJson from "./data.json";

export default function Home({ data }) {
  return (
    <div>
      <Layout locationRouter="hk" page={data.page}>
        <HongKongEcommerceGuideTemplate data={dataJson} posts={data.posts} />
      </Layout>
    </div>
  );
}

export const getStaticProps = async () => {
  const locale = "hk";
  const uri = "/guide-and-tool/hong-kong-ecommerce-guide";
  const page = await fetchSeo({
    uri,
    locale,
  });
  const posts = await fetchCategoryPosts({
    name: "/e-commerce",
    locale,
    size: "LARGE",
    variables: [
      {
        name: "where",
        type: "CategoryToPostConnectionWhereArgs",
        value: {
          in: [3958, 12279, 12708, 4061, 12528, 12925],
        },
      },
    ],
  });

  return {
    props: {
      data: {
        page: page || {},
        posts: posts || {},
      },
      revalidate: 1,
    },
  };
};
